<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏-->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索条件：
                        <el-input size="mini" placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select size="mini" v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option v-for="item in keywordList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-input>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV"> <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true" /> </el-button>
                </div>
            </div>
            <div v-show="showFV" >
                <div class="yx-flex-h-start" style="margin-top: 15px;">
                    <div>商户编号： <el-input placeholder="商户编号" v-model="searchVal.mchNo" clearable size="mini" style="width: 180px; margin-right: 15px;"/></div>
                    <div>终端编号： <el-input placeholder="终端编号" v-model="searchVal.terNo" clearable size="mini" style="width: 130px; margin-right: 15px;"/></div>
                    <div>支付渠道：
                        <el-select clearable v-model="searchVal.payWayCode" placeholder="支付渠道" size="mini" style="width: 120px;margin-right: 15px;">
                            <el-option v-for="item in this._enums.PayWayEnum" :key="item.id" :label="item.name" :value="item.id"/>
                        </el-select>
                    </div>
                    <div>
                        支付方式：
                        <el-select clearable v-model="searchVal.payModeCode" placeholder="支付方式" size="mini" style="width: 120px;margin-right: 15px;">
                            <el-option v-for="item in this._enums.PayModeEnum" :key="item.id" :label="item.name" :value="item.id"/>
                        </el-select>
                    </div>
                </div>
                <div class="yx-flex-h-start" style="margin-top: 15px;">
                    <div>交易日期： <el-date-picker v-model="searchVal.transDateScope" value-format="yyyy-MM-dd" style="margin-right: 15px;width:250px" type="daterange" size="mini" unlink-panels start-placeholder="开始日期" range-separator="至" end-placeholder="结束日期" /></div>

                    <div>
                        金额范围：
                        <el-input v-model="searchVal.minAmount" size="mini" clearable style="width: 160px;margin-right: 0px;">
                            <span slot="append">元</span>
                        </el-input>
                        -
                        <el-input v-model="searchVal.maxAmount" size="mini" clearable style="width: 160px;margin-right: 15px;">
                            <span slot="append">元</span>
                        </el-input>
                    </div>

                </div>


            </div>
        </div>
        <!-- 数据栏 -->
        <div class="yx-div-center">
            <el-table
                    :data="jnl"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%;">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <div style="font-size: 12px;">
                            <el-form label-position="left" class="demo-table-expand">
                                <el-form-item label="订单号">{{ props.row.payOrderNo }}</el-form-item>
                                <el-form-item label="通道商户号">{{ props.row.channelMchNo }}</el-form-item>
                                <el-form-item label="交易账号">{{ props.row.buyerId }}</el-form-item>
                                <el-form-item label="支付渠道">{{_enums.PayWayEnum.getNameById(props.row.payWayCode)}}</el-form-item>
                                <el-form-item label="支付方式">{{_enums.PayModeEnum.getNameById(props.row.payModeCode)}}</el-form-item>
                                <el-form-item label="设备SN">{{ props.row.terSn }}</el-form-item>
                                <el-form-item label="终端QR">{{ props.row.terNo }}</el-form-item>
                            </el-form>
                            <el-form label-position="left" class="demo-table-expand"
                                     v-if="_enums.PaySourceEnum['收款单'].id === props.row.paySource && props.row.skdOrder && props.row.skdOrder.skInfoObj && props.row.skdOrder.skInfoObj.list">
                                <el-divider><i class="el-icon-mobile-phone"></i></el-divider>
                                <el-form-item label="收款单号">{{ props.row.skdOrder.skOrderNo }}</el-form-item>
                                <el-form-item label="支付单号">{{ props.row.skdOrder.payOrderNo }}</el-form-item>
                                <el-form-item v-for="(item, index) in props.row.skdOrder.skInfoObj.list" :key="index" :label="item.key">{{ item.value }}</el-form-item>
                            </el-form>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="mchInfo.mchName" label="商户名称" width="100" show-overflow-tooltip />
                <el-table-column prop="mchInfo.shortName" label="商户简称" width="100" show-overflow-tooltip />
                <el-table-column prop="mchNo" label="商户号" align="center" width="100" />
                <el-table-column prop="terNo" label="终端号" align="center" width="100" show-overflow-tooltip />
                <!--
                <el-table-column prop="terSn" label="设备SN" align="center" width="110" show-overflow-tooltip  />
                -->
                <el-table-column prop="payWayCode" label="渠道" align="center" width="60" >
                    <template slot-scope="scope">
                        {{_enums.PayWayEnum.getNameById(scope.row.payWayCode)}}
                    </template>
                </el-table-column>
                <el-table-column prop="payModeCode" label="方式" align="center" width="60" >
                    <template slot-scope="scope">
                        <div v-if="_enums.PaySourceEnum['收款单'].id === scope.row.paySource">
                            收款单
                        </div>
                        <div v-else>
                            {{_enums.PayModeEnum.getNameById(scope.row.payModeCode)}}
                        </div>
                    </template>
                </el-table-column>


                <el-table-column prop="type" label="交易类型" align="center" width="80" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.type===1">
                            {{_enums.PayOrderTypeEnum.getNameById(scope.row.type)}}
                        </div>
                        <div v-else style="color: red; font-weight: bolder;">
                            <el-tag type="danger">
                                {{_enums.PayOrderTypeEnum.getNameById(scope.row.type)}}
                            </el-tag>
                        </div>
                    </template>
                </el-table-column>


                <el-table-column prop="amount" label="交易金额" align="right" width="100" :formatter="funFmtTransAmt" sortable />
                <!--
                <el-table-column prop="channelMerFee" label="手续费" align="right" width="80" :formatter="funFmtTransFee" />
                <el-table-column prop="channelMerFeeD0" label="D0费" align="right" width="70" :formatter="funFmtTransFeeD0" />
                <el-table-column prop="settleAmt" label="实拨金额" align="right" width="100" :formatter="funFmtTransSettle" />
                <el-table-column label="收益金额" align="right" width="90">
                    <template slot="header">
                        <el-tooltip effect="light" placement="top">
                            <div slot="content" >
                                <el-tag type="default" style="font-weight: bolder">蓝</el-tag>-<span style="color: blue;">直拓收益</span>
                                <br/>
                                <el-tag type="danger" style="font-weight: bolder">红</el-tag>-<span style="color: red;">间推收益</span>
                            </div>
                            <span style="color: green;">收益金额 <i class="el-icon-question"/></span>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <span style="color: blue; font-weight: bolder" v-if="scope.row.mchInfo.agentId===user.agentIdS">{{scope.row.agentEarning}}</span>
                        <span style="color: red; font-weight: bolder" v-else>{{scope.row.agentParentEarning}}</span>
                    </template>
                </el-table-column>
                -->
                <el-table-column prop="paySuccTime" label="交易日期" align="center" width="95" :formatter="funDateFormatter" />
                <el-table-column prop="paySuccTime" label="交易时间" align="center" width="80" :formatter="funTimeFormatter" />
                <el-table-column prop="agentName" label="服务商" width="100" show-overflow-tooltip />
                <el-table-column prop="mchInfo.salesmanName" label="客户经理" width="80" show-overflow-tooltip />
                <!--
                <el-table-column prop="buyerId" label="交易账号" align="center" width="135" show-overflow-tooltip />
                <el-table-column prop="payOrderNo" label="订单号" align="center" width="160" />
                <el-table-column prop="channelMchNo" label="通道商户号" align="center" width="150" />
                -->
                <!--
                -->
            </el-table>
        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="height:32px;line-height: 32px; font-family: 'Arial Black'; font-size: 15px; background-color:green; color: white; padding-left: 15px;padding-right: 15px; ">{{msgInfo}}</div>
            <div class="yx-flex-h-end">
                <el-pagination :current-page.sync="page" @current-change="currentChange" @size-change="sizeChange" layout="sizes, prev,pager,next, jumper,->, total, slot" :total="total" />
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        name: "RptMchTraDet",
        data() {
            return {
                loading: false,
                showFV: false,
                total: 0,
                msgInfo: 0,
                page: 1,
                size: 10,
                jnl: [],
                keywordList: [
                    {id:"mchInfo.mchName",name:"商户名称"},
                    {id:"mchInfo.shortName",name:"商户简称"},
                    {id:"mchInfo.salesmanName",name:"客户经理名称"},
                    {id:"mchInfo.agentName",name:"服务商名称"},
                    {id:"device",name:"设备序号"},
                ],
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    mchInfo: {
                        agentId: null,
                        salesmanId: null,
                        mchNo: null,
                        status: null,
                        mchName: null,
                        shortName: null,
                        salesmanName: null,
                        agentName: null,
                        outMchNo: null,
                        createWay: null
                    },
                    mchNo : null,
                    terNo : null,
                    payWayCode : null,
                    payModeCode : null,
                    transDateScope : null,
                    minAmount: null,
                    maxAmount: null
                },
            }
        },
        mounted() {
            this.initJnl();
        },
        computed: {
            user() {
                return this.$store.state.currentHr;
            }
        },
        methods: {
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.page = 1;
                this.initJnl();
            },
            initJnl() {
                this.loading = true;
                let url = '/rpt/agent/mch/transDetails/?page=' + this.page + '&size=' + this.size;
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.mchNo)
                    url += '&mchInfo.mchNo=' + this.searchVal.mchNo;
                if (this.searchVal.terNo)
                    url += '&terNo=' + this.searchVal.terNo;
                if (this.searchVal.payWayCode)
                    url += '&payWayCode=' + this.searchVal.payWayCode;
                if (this.searchVal.payModeCode)
                    url += '&payModeCode=' + this.searchVal.payModeCode;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                if (this.searchVal.minAmount)
                    url += '&minAmount=' + this.searchVal.minAmount;
                if (this.searchVal.maxAmount)
                    url += '&maxAmount=' + this.searchVal.maxAmount;

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.jnl = resp.data;
                        this.total = resp.total;
                        this.msgInfo = resp.msgInfo;
                    }
                });
            },
            exportData() {
                window.open('/bill/export', '_parent');
            },
            funFmtTransAmt(row, column) {
                return row.amount.toFixed(2);
            },
            funFmtTransFee(row, column) {
                return row.channelMerFee.toFixed(2);
            },
            funFmtTransFeeD0(row, column) {
                return row.channelMerFeeD0.toFixed(2);
            },
            funFmtTransSettle(row, column) {
                return row.settleAmt.toFixed(2);
            },
            funFmtTemp(row, column) {
                return Number(row.amount - row.channelMerFee).toFixed(2);
            },
            // 日期格式化
            funDateFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(0,10);
                }
                return tm;
            },
            // 时间格式化
            funTimeFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(11,19);
                }
                return tm;
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initJnl();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initJnl();
            },
        }
    }
</script>

<style>

</style>
